package dev.valvassori.minesweeper.ext

import kotlinx.coroutines.flow.MutableStateFlow

fun MutableStateFlow<Int>.inc(): Int {
    value = value.inc()
    return value
}
